export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": "Rion Wildlife Safaris",
  "url": "https://rionwildlifesafaris.com",
  "logo": "https://rionwildlifesafaris.com/logo.png",
  "sameAs": [
    "https://www.facebook.com/rionwildlifesafaris",
    "https://www.instagram.com/rionwildlifesafaris",
    "https://twitter.com/rionwildlifesafaris"
  ],
  "description": "Premium safari experiences across Namibia, Botswana, and Victoria Falls, led by Professor Rion Haraeb with over 20 years of experience.",
  "founder": {
    "@type": "Person",
    "name": "Professor Rion Haraeb",
    "jobTitle": "Safari Guide and Founder"
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "Namibia",
    "addressLocality": "Windhoek"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+264 81 323 6891",
    "email": "rionwildlifesafaris@gmail.com",
    "contactType": "Customer Service"
  },
  "areaServed": [
    {
      "@type": "Country",
      "name": "Namibia"
    },
    {
      "@type": "Country",
      "name": "Botswana"
    },
    {
      "@type": "Country",
      "name": "Zimbabwe"
    }
  ]
};

export const tourSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": "Namibia Highlights Safari",
    "description": "A 14-day journey through Namibia's highlights including Windhoek, Kalahari Desert, Sossusvlei, Swakopmund, Spitzkoppe, Twyfelfontein, and Etosha National Park.",
    "touristType": ["Nature Lovers", "Wildlife Enthusiasts", "Photographers"],
    "offers": {
      "@type": "Offer",
      "price": "3600",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://rionwildlifesafaris.com/tours/namibia-highlights"
    },
    "itinerary": {
      "@type": "ItemList",
      "numberOfItems": 14,
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "TouristAttraction",
            "name": "Windhoek (Okapuka Ranch)"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "TouristAttraction",
            "name": "Kalahari Desert (Kalahari Anib Lodge)"
          }
        }
      ]
    },
    "subjectOf": {
      "@type": "CreativeWork",
      "name": "Namibia Highlights Safari Guide",
      "author": {
        "@type": "Person",
        "name": "Professor Rion Haraeb"
      }
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": "Big Five Safari (Nambovic)",
    "description": "A 19-day safari adventure from Namibia to Botswana, featuring Etosha, Chobe, and Big Five spotting.",
    "touristType": ["Wildlife Enthusiasts", "Nature Photographers"],
    "offers": {
      "@type": "Offer",
      "price": "4800",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://rionwildlifesafaris.com/tours/big-five-safari"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": "Namwild",
    "description": "A 9-day wildlife-focused safari through Windhoek, Swakopmund, and Etosha.",
    "touristType": ["Wildlife Enthusiasts"],
    "offers": {
      "@type": "Offer",
      "price": "1900",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://rionwildlifesafaris.com/tours/namwild"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": "Namibia, Botswana, Victoria Falls",
    "description": "An 18-day multi-country tour with Chobe, Okavango Delta, and Victoria Falls highlights.",
    "touristType": ["Adventure Travelers", "Nature Lovers"],
    "offers": {
      "@type": "Offer",
      "price": "4500",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://rionwildlifesafaris.com/tours/namibia-botswana-victoria-falls"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": "Walvisbay Excursions",
    "description": "Photography-focused day tours featuring Pink Lake, Dune 7, Welwitschia, and Moonlandscape.",
    "touristType": ["Photographers", "Day Trippers"],
    "offers": {
      "@type": "Offer",
      "price": "80",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://rionwildlifesafaris.com/tours/walvisbay-excursions"
    }
  }
];

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What languages does Rion Wildlife Safaris offer tours in?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Professor Rion Haraeb offers tours in both English and German, catering to international clients."
      }
    },
    {
      "@type": "Question",
      "name": "What is included in the safari tour price?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our safari prices include accommodations, transportation, airport transfers, guided drives, and cultural visits as specified in the itinerary."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book a safari with Rion Wildlife Safaris?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book by contacting Professor Rion directly via email or phone. A 70% deposit is required to secure your booking, with the remaining 30% due upon completion of the tour."
      }
    },
    {
      "@type": "Question",
      "name": "What wildlife can I expect to see on safari?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Depending on your chosen tour, you may see the Big Five (lion, leopard, elephant, buffalo, rhino), desert elephants, cheetahs, and numerous other species native to Southern Africa."
      }
    }
  ]
}; 